var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-pagination',{staticClass:"custom-pagination",attrs:{"prev-icon":"fa fa-angle-double-left","next-icon":"fa fa-angle-double-right","length":_vm.totalPages,"total-visible":7},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }